import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1343c5c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-flush h-xl-100" }
const _hoisted_2 = { class: "card-header pt-7" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"card-toolbar\" data-v-1343c5c2><ul class=\"nav\" data-v-1343c5c2><li class=\"nav-item\" data-v-1343c5c2><a class=\"nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 active\" data-bs-toggle=\"tab\" href=\"#kt_table_widget_5_tab_1\" data-v-1343c5c2><span class=\"svg-icon svg-icon-1x m-0\" data-v-1343c5c2><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-1343c5c2><path opacity=\"0.3\" d=\"M2 21V14C2 13.4 2.4 13 3 13H21C21.6 13 22 13.4 22 14V21C22 21.6 21.6 22 21 22H3C2.4 22 2 21.6 2 21Z\" fill=\"black\" data-v-1343c5c2></path><path d=\"M2 10V3C2 2.4 2.4 2 3 2H21C21.6 2 22 2.4 22 3V10C22 10.6 21.6 11 21 11H3C2.4 11 2 10.6 2 10Z\" fill=\"black\" data-v-1343c5c2></path></svg></span></a></li><li class=\"nav-item\" data-v-1343c5c2><a class=\"nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1\" data-bs-toggle=\"tab\" href=\"#kt_table_widget_5_tab_2\" data-v-1343c5c2><span class=\"svg-icon svg-icon-1x m-0\" data-v-1343c5c2><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-1343c5c2><path d=\"M3 2H10C10.6 2 11 2.4 11 3V10C11 10.6 10.6 11 10 11H3C2.4 11 2 10.6 2 10V3C2 2.4 2.4 2 3 2Z\" fill=\"black\" data-v-1343c5c2></path><path opacity=\"0.3\" d=\"M14 2H21C21.6 2 22 2.4 22 3V10C22 10.6 21.6 11 21 11H14C13.4 11 13 10.6 13 10V3C13 2.4 13.4 2 14 2Z\" fill=\"black\" data-v-1343c5c2></path><path opacity=\"0.3\" d=\"M3 13H10C10.6 13 11 13.4 11 14V21C11 21.6 10.6 22 10 22H3C2.4 22 2 21.6 2 21V14C2 13.4 2.4 13 3 13Z\" fill=\"black\" data-v-1343c5c2></path><path opacity=\"0.3\" d=\"M14 13H21C21.6 13 22 13.4 22 14V21C22 21.6 21.6 22 21 22H14C13.4 22 13 21.6 13 21V14C13 13.4 13.4 13 14 13Z\" fill=\"black\" data-v-1343c5c2></path></svg></span></a></li></ul></div>", 1)
const _hoisted_7 = {
  key: 0,
  class: "card-body pt-2"
}
const _hoisted_8 = { class: "position-relative mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "hover-scroll-overlay-y pe-6 me-n6 course-h-100 courseCard-200" }
const _hoisted_12 = { class: "tab-content" }
const _hoisted_13 = {
  class: "tab-pane fade show active",
  id: "kt_table_widget_5_tab_1"
}
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = ["onChange", "value", "id"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { class: "flex-grow-1 text-start" }
const _hoisted_18 = { class: "text-dark fw-bolder d-block fs-4 mb-0" }
const _hoisted_19 = { class: "text-muted fw-bold fs-7" }
const _hoisted_20 = { class: "badge badge-warning fs-8 fw-bolder" }
const _hoisted_21 = {
  key: 1,
  class: "row"
}
const _hoisted_22 = ["onChange", "value", "id"]
const _hoisted_23 = ["for"]
const _hoisted_24 = { class: "flex-grow-1 text-start" }
const _hoisted_25 = { class: "text-dark fw-bolder d-block fs-4 mb-0" }
const _hoisted_26 = { class: "text-muted fw-bold fs-7" }
const _hoisted_27 = { class: "badge badge-warning fs-8 fw-bolder" }
const _hoisted_28 = {
  key: 0,
  class: "tab-pane fade",
  id: "kt_table_widget_5_tab_2"
}
const _hoisted_29 = { class: "form-check form-check-custom form-check-solid me-5" }
const _hoisted_30 = ["onChange", "value"]
const _hoisted_31 = { class: "flex-grow-1" }
const _hoisted_32 = {
  href: "Javascript:;",
  class: "text-gray-800 text-hover-primary fw-bolder fs-6"
}
const _hoisted_33 = { class: "text-muted fw-bold d-block" }
const _hoisted_34 = { class: "badge badge-warning fs-8 fw-bolder" }
const _hoisted_35 = {
  key: 1,
  class: "tab-pane fade",
  id: "kt_table_widget_5_tab_2"
}
const _hoisted_36 = { class: "form-check form-check-custom form-check-solid me-5" }
const _hoisted_37 = ["onChange", "value"]
const _hoisted_38 = { class: "flex-grow-1" }
const _hoisted_39 = {
  href: "Javascript:;",
  class: "text-gray-800 text-hover-primary fw-bolder fs-6"
}
const _hoisted_40 = { class: "text-muted fw-bold d-block" }
const _hoisted_41 = { class: "badge badge-warning fs-8 fw-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate("offeredCourses.offeredCourses")), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translate("offeredCourses.desc")), 1)
      ]),
      _hoisted_6
    ]),
    (_ctx.registerToCoursesRes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.registerToCoursesResChange && _ctx.registerToCoursesResChange(...args))),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.registerToCoursesResChange && _ctx.registerToCoursesResChange(...args))),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
              type: "text",
              class: "form-control form-control-solid ps-10",
              placeholder: _ctx.translate('offeredCourses.search')
            }, null, 40, _hoisted_10), [
              [_vModelText, _ctx.searchQuery]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_ctx.searchQuery)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchQueryOutput, (course) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-md-12",
                          key: course.eD_COURSE_ID
                        }, [
                          _createElementVNode("input", {
                            onChange: ($event: any) => (_ctx.$emit('loadSection', course)),
                            type: "radio",
                            class: "btn-check",
                            name: "account_type",
                            value: course.eD_COURSE_ID,
                            id: 
                    'kt_create_account_form_account_type_personal' +
                    course.eD_COURSE_ID
                  
                          }, null, 40, _hoisted_15),
                          _createElementVNode("label", {
                            class: "btn btn-outline btn-outline-dashed btn-outline-default p-5 d-flex align-items-center mb-3 bg-white",
                            for: 
                    'kt_create_account_form_account_type_personal' +
                    course.eD_COURSE_ID
                  
                          }, [
                            _createElementVNode("span", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(course.coursE_CODE), 1),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(course.coursE_DESCR) + " - " + _toDisplayString(_ctx.translate("regisCourses.CH")) + " :: " + _toDisplayString(course.crediT_HOURS), 1)
                            ]),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(course.hdR_DESCR), 1)
                          ], 8, _hoisted_16)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registerToArray, (course) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-md-12",
                          key: course.eD_COURSE_ID
                        }, [
                          _createElementVNode("input", {
                            onChange: ($event: any) => (_ctx.$emit('loadSection', course)),
                            type: "radio",
                            class: "btn-check",
                            name: "account_type",
                            value: course.eD_COURSE_ID,
                            id: 
                    'kt_create_account_form_account_type_personal' +
                    course.eD_COURSE_ID
                  
                          }, null, 40, _hoisted_22),
                          _createElementVNode("label", {
                            class: "btn btn-outline btn-outline-dashed btn-outline-default p-5 d-flex align-items-center mb-3 bg-white",
                            for: 
                    'kt_create_account_form_account_type_personal' +
                    course.eD_COURSE_ID
                  
                          }, [
                            _createElementVNode("span", _hoisted_24, [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(course.coursE_CODE), 1),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(course.coursE_DESCR) + " - " + _toDisplayString(_ctx.translate("regisCourses.CH")) + " :: " + _toDisplayString(course.crediT_HOURS), 1)
                            ]),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(course.hdR_DESCR), 1)
                          ], 8, _hoisted_23)
                        ]))
                      }), 128))
                    ]))
              ]),
              (_ctx.searchQuery)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchQueryOutput, (course) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex align-items-center mb-8",
                        key: course.eD_COURSE_ID
                      }, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("input", {
                            onChange: ($event: any) => (_ctx.$emit('loadSection', course)),
                            class: "form-check-input",
                            type: "radio",
                            name: "course-radio",
                            value: course.eD_COURSE_ID
                          }, null, 40, _hoisted_30)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("a", _hoisted_32, _toDisplayString(course.coursE_CODE), 1),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(course.coursE_DESCR) + " - " + _toDisplayString(_ctx.translate("regisCourses.CH")) + ":: " + _toDisplayString(course.crediT_HOURS), 1)
                        ]),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(course.hdR_DESCR), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registerToArray, (course) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex align-items-center mb-8",
                        key: course.eD_COURSE_ID
                      }, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("input", {
                            onChange: ($event: any) => (_ctx.$emit('loadSection', course)),
                            class: "form-check-input",
                            type: "radio",
                            name: "course-radio",
                            value: course.eD_COURSE_ID
                          }, null, 40, _hoisted_37)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("a", _hoisted_39, _toDisplayString(course.coursE_CODE), 1),
                          _createElementVNode("span", _hoisted_40, _toDisplayString(course.coursE_DESCR) + " - " + _toDisplayString(_ctx.translate("regisCourses.CH")) + ":: " + _toDisplayString(course.crediT_HOURS), 1)
                        ]),
                        _createElementVNode("span", _hoisted_41, _toDisplayString(course.hdR_DESCR), 1)
                      ]))
                    }), 128))
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}